import { Network } from '@spritz-finance/sdk'
import { useCallback } from 'react'
import { useWeb3Connection } from '../../../../../web3/Web3Provider'
import { useGasPrice } from '../gas/getGasPrice'

const networkGasLimit = {
    payWithToken: {
        [Network.Polygon]: '110000',
        [Network.Ethereum]: '110000',
        [Network.Binance]: '110000',
        [Network.Avalanche]: '110000',
        [Network.Arbitrum]: '900000',
        [Network.Optimism]: '110000',
    },
    payWithSwap: {
        [Network.Polygon]: '310000',
        [Network.Binance]: '310000',
        [Network.Avalanche]: '310000',
        [Network.Ethereum]: '340000',
        [Network.Arbitrum]: '2000000',
        [Network.Optimism]: '320000',
    },
    payWithV3Swap: {
        [Network.Ethereum]: '340000',
        [Network.Arbitrum]: '1600000',
        [Network.Optimism]: '320000',
    },
    payWithNativeSwap: {
        [Network.Ethereum]: '340000',
        [Network.Arbitrum]: '2000000',
        [Network.Optimism]: '320000',
        [Network.Polygon]: '310000',
        [Network.Binance]: '310000',
        [Network.Avalanche]: '310000',
    },
}

export const useGasSettings = () => {
    const { connectedNetwork } = useWeb3Connection()
    const _getGasPrice = useGasPrice()

    const getGasOverride = useCallback(
        async (paymentFunction: string) => {
            const gasPrice = Math.ceil(await _getGasPrice())
            const gasLimit = networkGasLimit[paymentFunction]?.[connectedNetwork!] ?? null

            console.log('Setting gas price: ', { gasPrice, gasLimit })

            return gasPrice && gasLimit ? { gasPrice: gasPrice.toString(), gasLimit } : null
        },
        [_getGasPrice, connectedNetwork]
    )

    return { getGasOverride }
}
